import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Routes } from "router";

import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import { request, ResponseError } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

type BonusStatisticsReportParams = {
  startDate: string;
  endDate: string;
};

// The endpoint returns an .xlsx file, so this can't go through useFetch, which always parses JSON.
export const useBonusStatisticsReport = () => {
  const { token, clearToken } = useAuth();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ startDate, endDate }: BonusStatisticsReportParams) => {
      const response = await request(
        `${Urls.BonusStatistics}?startDate=${startDate}&endDate=${endDate}`,
        { method: "GET" },
        true,
        token,
      );

      if (response.status === 401) {
        clearToken();
        navigate(Routes.SignIn, { state: { from: location.pathname } });
      }

      if (!response.ok) {
        throw new ResponseError(response.status, await response.text());
      }

      return response.blob();
    },
    onError: (error) => {
      if (error instanceof ResponseError && error.status === 401) return;

      toast.error(error.message || "Не вдалося отримати звіт по бонусах");
    },
  });
};
